import { Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';

type Props = {
    open: boolean;
    messageType: MessageTypes;
    onConfirm: () => void;
    onCancel: () => void;
};

const ContinueWithErrorsModal = ({ open, messageType, onConfirm, onCancel }: Props) => (
    <ConfirmationModal
        open={open}
        type="warning"
        icon={<ExclamationCircleOutlined />}
        title="Continue with unresolved errors?"
        confirmButtonText="Continue Anyway"
        cancelButtonText="Keep Fixing"
        onConfirm={onConfirm}
        onCancel={onCancel}
        onClose={onCancel}
        content={
            <Typography>
                Some items are still missing details required for generation. If you continue, the {messageType} will be
                generated with those fields empty and you'll need to complete them on the generated declaration before
                it can be submitted.
            </Typography>
        }
    />
);

export default ContinueWithErrorsModal;
